module.exports = __webpack_public_path__ + "static/media/YB5M16_7.574ed562.jpg";